/** @file pasteImage: Ctrl+V in the viewport: the clipboard's PNG into the selected part's shown tile. */
import { fillPartImage } from './fillPartImage';
import { quadTarget } from './quadTarget';
import type { ViewportCtx } from './viewportCtx';

/**
 * The part `quadTarget` names (the selected drawable, else the active node's first drawable) gets the clipboard's
 * PNG (`fillPartImage`, label "Fill <slot> from paste"); a toast when no part is selected or the clipboard holds no
 * PNG. `read` gives the pasted PNG bytes (`pastedPng` of the paste event), null without one.
 */
export async function pasteImage(ctx: ViewportCtx, read: () => Promise<Uint8Array | null>): Promise<boolean> {
  if (ctx.mode !== 'edit') return false;
  const target = quadTarget(ctx);
  if (target < 0) { ctx.store.getState().notify('warning', 'Select a part to paste the image onto'); return false; }
  const png = await read();
  if (png === null) { ctx.store.getState().notify('warning', 'The clipboard holds no PNG image'); return false; }
  return fillPartImage(ctx, target, png, 'paste');
}
